import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// Select-only subcategory picker. Options come strictly from the chosen
// category's managed `subcategories` list — no free typing. To add new
// subcategories, use the Kategoriler (admin) page.
export function SubcategoryInput({ categories = [], category, value, onChange, className, testid }) {
  const cat = categories.find((c) => c.name === category);
  const options = cat?.subcategories || [];
  // keep an existing (legacy free-typed) value selectable even if it's not in the list
  const opts = value && !options.includes(value) ? [...options, value] : options;
  const disabled = opts.length === 0;
  const selectValue = value ? value : (disabled ? undefined : "none");

  return (
    <Select value={selectValue} onValueChange={(v) => onChange(v === "none" ? "" : v)} disabled={disabled}>
      <SelectTrigger data-testid={testid} className={className}>
        <SelectValue placeholder={disabled ? "Alt kategori tanımlı değil" : "Alt kategori seç"} />
      </SelectTrigger>
      <SelectContent className="bg-surface border-border text-foreground max-h-64">
        {!disabled && <SelectItem value="none">— Yok</SelectItem>}
        {opts.map((s) => (
          <SelectItem key={s} value={s} data-testid={testid ? `${testid}-option-${s}` : undefined}>{s}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
